import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import { getRuntime } from '../../common/lib/runtime';

const runtime = getRuntime();

i18next //
    .use(initReactI18next)
    .use(HttpApi)
    .init({
        interpolation: { escapeValue: false },
        lng: 'fi',
        debug: false, //!runtime.isProd,
        ns: ['common', 'validation'],
        backend: {
            loadPath: `${runtime.isProd ? '/client-apps' : ''}/locales/{{lng}}/{{ns}}.json?v=${runtime.build}`,
        },
        fallbackLng: 'fi',
        react: {
            useSuspense: true,
        },
    });
